import * as React from 'react';
import { translateToNode } from '../../styles/global/translate';
import alertPopup, { AlertProps, AlertPropsDelete } from './Alert';

export enum AlertRes {
  Ok,
  Break
}

export type AlertResWithData<OkData = undefined, BreakData = undefined> =
  | {
      res: AlertRes.Ok;
      data: OkData;
    }
  | {
      res: AlertRes.Break;
      data?: BreakData;
    };
export type AlertCall = <OkData = undefined, BreakData = undefined>(
  p: AlertProps<OkData>
) => Promise<AlertResWithData<OkData, BreakData>>;
export type AlertCallDelete = <OkData = undefined, BreakData = undefined>(
  p: AlertPropsDelete & { name: string }
) => Promise<AlertResWithData<OkData, BreakData>>;
interface AlertContextType {
  alert: AlertCall;
  alertDelete: AlertCallDelete;
}

const defaultBehaviour: AlertContextType = {
	alert: async() => ({ res: AlertRes.Break }),
	alertDelete: async() => ({ res: AlertRes.Break })
};

export const AlertContext = React.createContext<AlertContextType>(
	defaultBehaviour
);

export function AlertProvider(props: { children: React.ReactNode }) {
	const [child, setChild] = React.useState<React.ReactNode>();

	async function alert<T = undefined>(props: AlertProps) {
		return alertPopup<T>({
			setChild,
			...props
		});
	}
	async function alertDelete<T = undefined>(
		props: AlertPropsDelete & { name: string }
	) {
		return alert<T>({
			mode: 'delete',
			title: translateToNode('global.fire.alert_title'),
			content: (
				<div>
					{translateToNode('global.fire.delete_message_node', {
						variables: [['NAME', props.name]]
					})}
				</div>
			),
			...props
		});
	}

	return (
		<AlertContext.Provider value={{ alert, alertDelete }}>
			{child}
			{props.children}
		</AlertContext.Provider>
	);
}
